import React from "react";
import { Link } from "react-router-dom";
import { Fade } from "react-reveal";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import { products } from "../../portfolio";
import { translate } from "../../i18n";
import "./Products.css";
import DarajatPage from "./DarajatPage";

export default function ProductDetails({ match, theme }) {
  const product = products.items.find(
    (item) => item.slug === match.params.slug
  );

  if (product && product.slug === "darajat") {
    return <DarajatPage theme={theme} product={product} />;
  }

  return (
    <div className="products-page">
      <Header theme={theme} />
      <main className="product-details-content">
        {!product ? (
          <section
            className="products-empty-state"
            style={{ backgroundColor: theme.highlight }}
          >
            <span
              className="iconify products-empty-icon"
              data-icon="mdi:progress-clock"
              data-inline="false"
              aria-hidden="true"
            ></span>
            <h1 style={{ color: theme.text }}>{products.emptyState}</h1>
            <Link className="products-back-link" to="/home#products">
              {translate("Back to Products")}
            </Link>
          </section>
        ) : (
          <Fade bottom duration={900} distance="30px">
            <article className="product-details">
              <Link className="products-back-link" to="/home#products">
                {translate("Back to Products")}
              </Link>
              {!product.image && product.icon && (
                <div className="product-details-symbol" aria-hidden="true">
                  <span className="iconify" data-icon={product.icon} />
                </div>
              )}
              {product.image && <img src={product.image} alt={product.name} />}
              <h1 style={{ color: theme.text }}>{product.name}</h1>
              <p style={{ color: theme.secondaryText }}>
                {product.description}
              </p>

              {product.features?.length > 0 && (
                <section className="product-features">
                  <h2 style={{ color: theme.text }}>
                    {translate("Product Features")}
                  </h2>
                  <ul style={{ color: theme.secondaryText }}>
                    {product.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </section>
              )}

              {product.downloadUrl && (
                <a
                  className="product-download-link"
                  href={product.downloadUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {translate("Download")}
                </a>
              )}
            </article>
          </Fade>
        )}
      </main>
      <Footer theme={theme} />
      <TopButton theme={theme} />
    </div>
  );
}
